import { useTranslation } from "react-i18next";
import { legendItemStyle, legendStyle } from "./style";

export const CrimeDatasetSweLegend = ({ customLegendStyle = legendStyle as React.CSSProperties }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{`Crime Dataset SWE`}</b>
      </div>
      <div>
        <span style={legendItemStyle("#ffffff")}></span>
        {t("levels.veryLow")}: 0 &lt; value &lt;= 7780
      </div>
      <div>
        <span style={legendItemStyle("#ffbfbf")}></span>
        {t("levels.low")}: 7780 &lt; value &lt;= 9092
      </div>
      <div>
        <span style={legendItemStyle("#ff8080")}></span>
        {t("levels.moderate")}: 9092 &lt; value &lt; 10294
      </div>
      <div>
        <span style={legendItemStyle("#ff4040")}></span>
        {t("levels.significant")}: 10294 &lt; value &lt;= 11840
      </div>
      <div>
        <span style={legendItemStyle("#ff0000")}></span>
        {t("levels.high")}: value &gt;= 11840
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          Number of reported crimes per 100,000 inhabitants in each municipality in 2024. Downloaded by
          Cystellar from the Swedish Civil Contingencies Agency (MSB).
        </span>
      </div>
    </div>
  );
};
